import React from "react";
import { Collapse, Flex, IconButton, Link, useDisclosure, VStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/pro-light-svg-icons";
export const NavLink = (props) => {
    const { isOpen, onToggle } = useDisclosure();
    return (props.navItem.children.length > 0 ?
        (React.createElement(Flex, { flexDirection: "column", alignItems: "flex-end" },
            React.createElement(Flex, { alignItems: "center", gap: 2 },
                React.createElement(IconButton, { onClick: onToggle, colorScheme: "blackAlpha", color: "brand.500", size: "xl", bg: "transparent", _hover: { bg: "gray.50" }, "aria-label": "Menü", icon: React.createElement(FontAwesomeIcon, { icon: isOpen ? faChevronDown : faChevronRight }) }),
                React.createElement(Link, { href: props.navItem.url, fontSize: "3xl", fontWeight: "black", color: "brand.500" }, props.navItem.label)),
            React.createElement(Collapse, { in: isOpen },
                React.createElement(VStack, { alignItems: "flex-end" }, props.navItem.children.map((item, i) => React.createElement(Link, { key: i, href: item.url }, item.label))))))
        :
            React.createElement(Link, { href: props.navItem.url, fontSize: "3xl", fontWeight: "black", color: "brand.500" }, props.navItem.label));
};
